let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4F9r2")).then(() => parcelRequire('1ZTTX'));